export enum RestApiRequestFormatType {
    Text = 'Text',
    Json = 'Json',
    Xml = 'Xml',
    FormData = 'FormData',
}
